import * as amplitude from '@amplitude/analytics-browser';
import { Identify } from '@amplitude/analytics-browser';
import { AccountType, Organization } from '@enview/interface/types/Organization';

const BOT_USER_AGENT_STRINGS = ['Prerender', 'HeadlessChrome'];
const FREE_ACCOUNT_TYPES = new Set([AccountType.Free, AccountType.FreeLegacy]);

let isPaidUser = false;

export const setPaidUser = (organizations: Organization[]): void => {
  isPaidUser = organizations.some((org) => !FREE_ACCOUNT_TYPES.has(org.accountStatus));
};

const isLikelyABot = (): boolean => {
  for (const str of BOT_USER_AGENT_STRINGS) {
    if (navigator.userAgent.includes(str)) {
      return true;
    }
  }
  return false;
};

const amplitudeKey = document.querySelector<HTMLMetaElement>(
  '[property="amplitude-key"]',
)?.content;

if (amplitudeKey && amplitudeKey.length > 0 && !isLikelyABot()) {
  amplitude.init(amplitudeKey, { defaultTracking: false, minIdLength: 1 });
}

const track = (event: string, properties?: Record<string, unknown>): void => {
  if (isLikelyABot() || !isPaidUser) return;
  amplitude.track(event, properties);
};

const identify = (userId: string, properties?: Record<string, unknown>): void => {
  if (isLikelyABot() || !isPaidUser) return;
  amplitude.setUserId(userId);
  if (properties) {
    const identifyEvent = new Identify();
    Object.entries(properties).forEach(([key, value]) => {
      identifyEvent.set(key, value as string);
    });
    amplitude.identify(identifyEvent);
  }
};

const group = (groupId: string, properties?: Record<string, unknown>): void => {
  if (isLikelyABot()) return;
  amplitude.setGroup('organization', groupId);
  if (properties) {
    const groupIdentifyEvent = new Identify();
    Object.entries(properties).forEach(([key, value]) => {
      groupIdentifyEvent.set(key, value as string);
    });
    amplitude.groupIdentify('organization', groupId, groupIdentifyEvent);
  }
};

const page = (
  category: string,
  name: string,
  properties?: Record<string, unknown>,
): void => {
  if (isLikelyABot() || !isPaidUser) return;
  amplitude.track('Page Viewed', { category, name, ...properties });
};

export { track, identify, group, page };
